import React from "react"
import { useSelector } from "react-redux"

import { selectChannelSubscriptions } from "@root/store/selectors"
import { useAppDispatch } from "@root/store"
import {
  loadChannelSubscriptions,
  subscribeChannel,
  unsubscribeChannel,
} from "@root/store/thunks"
import Subscriptions from "@root/components/Subscriptions"
import { channelToSubscriptionList } from "@root/store/utils"

const ChannelSubscriptions: React.FC = () => {
  const lists = useSelector(selectChannelSubscriptions)
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    dispatch(loadChannelSubscriptions())
  }, [dispatch])

  const addList = React.useCallback(
    (list: string) => dispatch(subscribeChannel(list)),
    [dispatch]
  )
  const removeList = React.useCallback(
    (list: string) => dispatch(unsubscribeChannel(list)),
    [dispatch]
  )

  return (
    <Subscriptions
      type="channel"
      lists={channelToSubscriptionList(lists)}
      onAddList={addList}
      onRemoveList={removeList}
    />
  )
}

export default ChannelSubscriptions
